<template>
    <ButtonTag
        :class="{'mr-1': hasMarginRight, 'd-none d-sm-inline-block': hideOnMobile,'mb-1': hasMarginDown, 'bg-white text-main font-bold hover:text-hoverMain focus-within:text-main border-gray-200 h-9 focus:ring-0 focus:outline-none': isBgWhite, 'focus:ring-0 focus:outline-none': noOutline}"
        :type="type"
        :variant="variant"
        :title="title"
        :url="url"
        :size="size"
        :do-action="doAction"
        :is-w100="false"
    >
        <span v-if="text" class="mr-1">
            {{ $t(text) + " &nbsp; &nbsp; " }}
        </span>
        <Icon :icon="icon" :size="faSize"/>
    </ButtonTag>
</template>

<script>
import ButtonTag from "./html/ButtonTag";
import Icon from "./html/Icon";

export default {
    name: "IconButton",
    components: {ButtonTag, Icon},
    props: {
        hideOnMobile: {
            type: Boolean,
            default: false,
        },
        hasMarginRight: {
            type: Boolean,
            default: true,
        },
        hasMarginDown: {
            type: Boolean,
            default: true,
        },
        noOutline: {
            type: Boolean,
            default: true,
        },
        isBgWhite: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            required: true,
        },

        // optional
        iconSize: {
            type: String,
            default: undefined,
        },

        // button
        type: {
            type: String,
            default: "button",
        },
        variant: {
            type: String,
            default: "info",
        },
        title: {
            type: String,
            default: "",
        },
        url: {
            type: String,
        },
        size: {
            type: String,
            default: "sm",
        },
        doAction: {
            type: Function,
            default: function () {
            }
        },
        text: {
            type: String,
            default: null
        }
    },
    computed: {
        attributes() {
            let result = {}

            if (this.url) {
                result.to = this.$i18nHelper.getUrl(this.url)
            }

            return result
        },
        faSize() {
            if (this.iconSize !== undefined) {
                return this.iconSize
            }

            switch (this.size) {
                case 'sm':
                    return 'sm'

                case 'md':
                    return 'lg'

                case 'lg':
                    return '2x'

                case 'xl':
                    return '3x'

                case 'xs':
                default:
                    return this.size
            }
        }
    },
}
</script>

<style scoped>

</style>